export enum Periods {
  TODAY = 'today',
  WEEK = 'week',
  MOUTH = 'month',
  YEAR = 'year',
}
export interface IReferralIncomes {
  totalIncome: number;
  takenIncome: number;
  notTakenIncome: number;
  isLoaded: boolean;
}

interface IINCOME {
  date: string;
  amount: number;
  count: number;
  lostCount: number;
  clicks: number;
}

export interface IReferralCampaign {
  id: number;
  name: string;
  code: string;
  appId: 2;
  createdAt: string;
  updatedAt: string;
  type: string;
  totalIncome: number;
  notTakenIncome: number;
  referralsCount: number;
  reports?: {
    incomes?: number;
    referrals?: number;
    incomesByTime?: {
      [Periods.TODAY]?: IINCOME[];
      [Periods.WEEK]?: IINCOME[];
      [Periods.MOUTH]?: IINCOME[];
      [Periods.YEAR]?: IINCOME[];
    };
  };
  referrals: IReferralCampaignMember[];
}

export interface IReferralCampaignMember {
  id: number;
  userId: number;
  referrerUserId: number;
  referralCampaignId: number;
  activated: boolean;
  createdAt: Date;
  updatedAt: Date;
  prevReferrerUserId: null;
  prevReferralCampaignId: null;
  deletedAt: Date;
  nextReferrerUserId: null;
  nextReferralCampaignId: null;
  rewardCoins: number;
  rewardCoinsTaken: number;
  next: null;
  status: IReferralCampaignMemberStatus;
  user: {
    id: number;
    avatar: string;
    name: string;
    profileType: string;
  };
}

export type IReferralCampaignMemberStatus = 'active' | 'lost' | 'inactive';

export interface IReferrals {
  incomes: IReferralIncomes;
  campaigns: Record<string, IReferralCampaign>;
  members: IReferralCampaignMember[];
}
